<template>
    <div class="user-center-container depth-4">
        <div class="user-center__header">
            <div class="back-icon" @click="handleGoBack" v-if="isUserCenter">
                <icon name="arrow-left" />
            </div>
            <div class="main-title">{{ $route.meta.title }}</div>
        </div>
        <div class="p-md">
            <div class="cell-container">
                <cell>
                    <template v-slot:title>
                        <span>{{ $t('账号名') }}：</span>
                    </template>
                    <span>{{ userDetail.username }}</span>
                </cell>
                <cell>
                    <template v-slot:title>
                        <span>{{ $t('邮箱') }}：</span>
                    </template>
                    <span>{{ userDetail.email || '-' }} </span>
                    <button class="btn btn-text btn-primary" @click="verifyMobile">
                        <span class="flex-row flex-center">
                            {{ userDetail.email ? $t('重新绑定') : $t('前往绑定') }}<icon name="arrow"/>
                        </span>
                    </button>
                </cell>
                <cell v-if="false">
                    <template v-slot:title>
                        <span>实名认证：</span>
                    </template>
                    <template v-if="userDetail.identity_card">
                        <span class="m-r-md">已认证</span>
                    </template>
                    <template v-else>
                        <button class="btn btn-text btn-primary" @click="verifyIdCard">
                            <span class="flex-row flex-center">前往认证<icon name="arrow"/></span>
                        </button>
                    </template>
                </cell>
                <cell>
                    <template v-slot:title>
                        <span>{{ $t('修改密码') }}：</span>
                    </template>
                    <button class="btn btn-text btn-primary" @click="changePassword">
                        <span class="flex-row flex-center">{{ $t('修改密码') }}<icon name="arrow"/></span>
                    </button>
                </cell>
                <cell v-if="false">
                    <template v-slot:title>
                        <span>隐私：</span>
                    </template>
                    <button class="btn btn-text btn-primary" @click="showPrivacyPolicy = true">
                        <span class="flex-row flex-center">个人信息收集清单<icon name="arrow"/></span>
                    </button>
                </cell>
                <cell>
                    <template v-slot:title>
                        <span>{{ $t('联系客服') }}：</span>
                    </template>
                    <span>xhskyxgs@gmail.com</span>
                </cell>
            </div>
            <button class="btn btn-primary btn-block" @click="onChangeAccount" v-if="showChangeAccount">{{ $t('切换账号') }}</button>
            <div class="empty-gap" />
            <button class="btn btn-primary btn-block" @click="handleBack" v-if="!isUserCenter">{{ $t('返回') }}</button>
        </div>
        <bind-mobile
            :type="userDetail.email ? 'rebind': 'bind'"
            @close="showBindMobile = false"
            @bind-success="bindMobileSuccess"
            v-if="showBindMobile"
        />
        <bind-id-card
            @close="showBindIdCard = false"
            @bind-success="showBindIdCard = false"
            v-if="showBindIdCard"
        />
        <reset-password
            type="reset"
            @close="showResetPassword = false"
            @reset-success="resetPasswordSuccess"
            v-if="showResetPassword"
        />
        <privacy-policy v-model="showPrivacyPolicy" />
    </div>
</template>

<script>
import { mapState } from 'vuex'
import { Cell, Icon } from 'vant'
import BindMobile from '@/views/BindMobile'
import BindIdCard from '@/views/BindIdCard'
import ResetPassword from '@/views/ResetPassword'
import PrivacyPolicy from '../components/PrivacyPolicy.vue'
import { setLocalAccountData } from '@/utils/storage'
import { getParams, translateUrlParams } from '@/utils/url'

export default {
    name: 'UserCenter',
    components: {
        ResetPassword,
        BindIdCard,
        BindMobile,
        PrivacyPolicy,
        Cell,
        Icon
    },
    data() {
        return {
            showResetPassword: false,
            showBindIdCard: false,
            showBindMobile: false,
            showPrivacyPolicy: false
        }
    },
    computed: {
        ...mapState({
            app: state => state.app,
            userDetail: state => state.user.userDetail,
        }),
        isUserCenter() {
            return getParams('is_user_center') || ''
        },
        /** 是否展示安卓 切换账号 按钮 */
        showChangeAccount() {
            return this.isUserCenter && window?.JsJingYouNativeBridge?.changeAccount instanceof Function
        }
    },
    methods: {
        verifyMobile() {
            this.showBindMobile = true
        },
        verifyIdCard() {
            this.showBindIdCard = true
        },
        changePassword() {
            this.showResetPassword = true
        },
        handleBack() {
            const gameFrame = this.$store.state.gameFrameInfo.frame ||
                document.getElementById(this.$store.state.gameFrameInfo.id)
            if (gameFrame) {
                gameFrame.style.visibility = 'visible'
            }

            this.$router.replace({
                path: '/login',
                query: {
                    ...this.$route.query,
                    ...this.app.originQuery,
                },
            })
        },
        onChangeAccount() {
            // 2025.08.25 回传安卓壳包 切换账号事件
            try {
                window?.JsJingYouNativeBridge?.changeAccount?.()
                console.log('JsJingYouNativeBridge.changeAccount<Android> | changeAccount >>> ')
            } catch (err) {
                console.error('>>> post Android changeAccount fail', err)
            }
        },
        bindMobileSuccess() {
            this.showBindMobile = false
        },
        resetPasswordSuccess() {
            this.showResetPassword = false
            // 2025.08.25 回传安卓壳包 绑定邮箱事件
            try {
                window?.JsJingYouNativeBridge?.changePsw?.()
                console.log('JsJingYouNativeBridge.changePsw<Android> | changePsw >>> ')
            } catch (err) {
                console.error('>>> post Android changePsw fail', err)
            }
        },
        handleGoBack() {
            // 2025.08.25 回传安卓壳包退出用户中心事件
            try {
                window?.JsJingYouNativeBridge?.closeView?.()
                console.log('JsJingYouNativeBridge.closeView<Android> | closeView >>> ')
            } catch (err) {
                console.error('>>> post Android closeView fail', err)
            }

            // 2022.03.31 针对ios直接跳到用户中心的需求
            window.close()
            const appElement = document.getElementById('app')
            appElement.style.display = 'none'

            history.back()
        }
    },
    mounted() {
        // 2022.03.31 针对ios直接跳到用户中心的需求
        if (this.$route.path === '/userCenter' && getParams('is_user_center')) {
            const localAccountData = { ...translateUrlParams() }
            this.$store.dispatch('updateAccountData', localAccountData)
            setLocalAccountData(localAccountData)

            console.log('userCenter >>> accountData >>>', localAccountData)
        }

        this.$store.dispatch('user/getUserDetail')
    },
}
</script>

<style scoped lang="scss">
.user-center__header {
    background-color: var(--theme-color);
    color: $white;
    padding: 12px;
    position: relative;
    display: flex;
    flex-direction: row;

    .back-icon {
        display: block;
        float: left;
    }

    .main-title {
        text-align: center;
        flex: 1;
    }
}

.user-center-container {
    background-color: #eeeeee;
    height: 100%;
    position: relative;
}

.cell-container {
    border-radius: 8px;
    border: 1px solid var(--border-color);
    overflow: hidden;
    margin-bottom: 12px;
}

.cell-container .van-cell__value {
    flex: 2
}

.empty-gap {
    height: 12px;
}
</style>
